import clsx from "clsx";
import React, { useRef } from "react";
import { useApiRequest } from "../hooks/useApiRequest";
import { Spinner } from "./base/Spinner";
import { View } from "./base/View";

type ImageFieldProps = {
  className?: string;
  onChange?: (fileUrl: string) => void;
  children: React.ReactNode;
  name?: string;
  isLoading?: boolean;
};

export const ImageField = ({ className, onChange = () => {}, children }: ImageFieldProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const apiRequest = useApiRequest<{ data: string }>();

  const onClickUpload = () => {
    fileInputRef.current?.click();
  };

  const onChangeInternal = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (file) {
      const response = await apiRequest.fetch("/v1/files/images", {
        method: "POST",
        file,
      });

      onChange(response.data?.data || "");
    }
  };

  return (
    <View className="relative">
      {React.Children.map(children, (child) => {
        if (React.isValidElement<HTMLButtonElement>(child)) {
          return React.cloneElement(child, {
            // @ts-ignore
            onClick: onClickUpload,
            isLoading: apiRequest.isLoading,
          });
        }

        return child;
      })}
      <input
        type="file"
        accept="image/*"
        className={clsx("rounded-full w-24 h-24 object-cover hidden", className)}
        onChange={onChangeInternal}
        ref={fileInputRef}
      />
      {apiRequest.isLoading && (
        <Spinner
          className="absolute top-12 left-[52px] w-full h-full"
          color="black"
        />
      )}
    </View>
  );
};
